import clockImage from "../../img/clockLogo.svg";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {DateTime} from "luxon";

const CurrentTime = () => {
    const { i18n, t: translate } = useTranslation();
    const picketDate = useSelector(state => state.dateReducer.currentDate);
    const timeZone = useSelector(state => state.branchReducer.timeZone);

    const locale = (i18n.language || "uk").toLowerCase();

    let dt =
        picketDate instanceof Date
            ? DateTime.fromJSDate(picketDate)
            : picketDate
                ? DateTime.fromISO(picketDate, { setZone: true })
                : DateTime.now();

    dt = dt.setZone(timeZone).setLocale(locale);

    const currentTime = dt.toFormat("HH:mm");
    const currentDate = dt.toFormat("dd.MM.yyyy");
    const dayOfWeek = dt.toFormat("cccc");

    return (
        <div className="timme-info d-flex align-items-center w-100">
            <div className="image-wrapper me-4 master-photo__wrapper rounded-circle">
                <img src={clockImage} className="d-block" alt="" />
            </div>
            <div className="info">
                <p className="text-secondary fs-18 mb-0">
                    {translate("branchMenuPage.dateAndTime")}
                </p>
                <p className="mb-0 fw-bold branch-name main_text_color icon_to_block d-flex align-items-center">
                    {currentDate}, {dayOfWeek}, {currentTime}
                </p>
            </div>
        </div>
    );
};

export default CurrentTime;